import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m8.923 3.472.938 1.877c.128.261.47.512.758.56l1.7.283c1.089.18 1.345.97.56 1.749l-1.322 1.322c-.224.224-.346.656-.277.966l.379 1.637c.298 1.296-.39 1.797-1.536 1.12l-1.595-.944c-.288-.171-.762-.171-1.056 0l-1.594.944c-1.141.677-1.835.17-1.536-1.12l.379-1.637c.069-.31-.054-.742-.278-.966L3.121 7.941c-.779-.779-.528-1.568.56-1.75l1.7-.282c.284-.048.625-.299.753-.56l.938-1.877c.512-1.019 1.344-1.019 1.85 0Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }